import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export enum Size {
    small = 'sm',
    normal = '',
    large = 'lg'
}

const noop = () => {};

@Component({
    selector: 'app-checkbox',
    templateUrl: 'checkbox.component.html',
    styleUrls: ['checkbox.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
    @Input() size: Size = Size.normal;
    @Input() color = 'black';
    @Input() disabled = false;
    @Input() label;
    @Input() tooltipTitle: string;
    @Input() icon: IconName;
    @Input() nullableCheckbox: boolean = false;

    private _value = false;
    private _disabled = false;
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    tape = [true, null, false];

    get value(): any {
        return this._value;
    }

    set value(v: any) {
        if (v !== this._value) {
            this._value = v;
            this.onChangeCallback(v);
        }
    }

    constructor() {}

    onClick() {
        if (this.disabled) return;
        if (this.nullableCheckbox) {
            const idx = this.tape.indexOf(this.value);
            this.value = this.tape[(idx + 1) % this.tape.length];
        } else {
            this.value = !this.value;
        }
    }

    get isIndeterminate(): boolean {
        return this.nullableCheckbox && this.value === null;
    }

    onBlur() {
        this.onTouchedCallback();
    }

    writeValue(value: boolean) {
        if (value !== this._value) {
            this._value = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this._disabled = isDisabled;
    }
}
